/* REST + Server-Sent Events client for sf_bw_bridge. The token lives in sessionStorage only. */
const TOKEN_KEY = 'sfBwBridgeToken';

export class BridgeClient {
    constructor(baseUrl) {
        this.setBase(baseUrl);
        this.token = null;
        this.es = null;
        this.orgId = '';          // Salesforce org ID: the bridge refuses a sign-in from another org
    }

    setBase(url) { this.base = String(url || '').replace(/\/$/, ''); }

    _store(token) {
        this.token = token;
        try { token ? sessionStorage.setItem(TOKEN_KEY, token) : sessionStorage.removeItem(TOKEN_KEY); } catch (e) { /* storage blocked */ }
    }

    useToken(token) { this._store(token); }

    async resume() {
        try { this.token = sessionStorage.getItem(TOKEN_KEY); } catch (e) { this.token = null; }
        if (!this.token) return false;
        try { await this.get('/api/calls'); return true; } catch (e) { this._store(null); return false; }
    }

    async login(userId, password) {
        const body = { userId, password };
        if (this.orgId) body.salesforceOrgId = this.orgId;
        const res = await this._fetch('POST', '/api/login', body, false);
        this._store(res.token);
        return res;
    }

    async logout() {
        try { await this.post('/api/logout', {}); } finally {
            if (this.es) this.es.close();
            this._store(null);
        }
    }

    openEvents(onMessage, onSessionEnded) {
        if (this.es) this.es.close();
        this.es = new EventSource(`${this.base}/api/events?token=${encodeURIComponent(this.token)}`);
        this.es.onmessage = (e) => {
            const msg = JSON.parse(e.data);
            if (msg.type === 'SESSION_ENDED') { this.es.close(); this._store(null); onSessionEnded(); return; }
            onMessage(msg);
        };
        // EventSource reconnects by itself; the bridge replays active calls in a SNAPSHOT.
    }

    get(path) { return this._fetch('GET', path); }
    post(path, body) { return this._fetch('POST', path, body); }
    put(path, body) { return this._fetch('PUT', path, body); }
    callAction(callId, action, body = {}) {
        return this.post(`/api/calls/${encodeURIComponent(callId)}/${action}`, body);
    }

    async _fetch(method, path, body, auth = true) {
        const headers = { 'Content-Type': 'application/json' };
        if (auth) headers.Authorization = `Bearer ${this.token}`;
        const r = await fetch(this.base + path, { method, headers, body: body ? JSON.stringify(body) : undefined });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error || `bridge HTTP ${r.status}`);
        return data;
    }
}
